import { Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { useAuth } from "./hooks/useAuth";
import { useTheme } from "./hooks/useTheme";
import { AuthListener } from "./components/AuthListener";
import AppToast from "./components/AppToast";
import { AuthenticatedRoutes } from "./components/AuthenticatedRoutes";
import TabsLayout from "./components/TabsLayout";
import LoginPage from "./pages/LoginPage";
import AcceptInvitePage from "./pages/AcceptInvitePage";
import OAuthConsentPage from "./pages/OAuthConsentPage";
import {
  NativeAuthRedirectBoundary,
  NativePushRegistrationBoundary,
  NativePushTapBoundary,
} from "./components/NativeBoundaries";

/* Ionic CSS */
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

import "./theme/variables.css";
import "./index.css";

setupIonicReact();

// Check for service worker updates every 15 minutes while the app is open.
// Without this, a PWA pinned to the homescreen may never discover new versions.
const SW_UPDATE_INTERVAL = 15 * 60 * 1000;
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    setInterval(() => registration.update(), SW_UPDATE_INTERVAL);
  });
}

function App() {
  const { initialized, user } = useAuth();
  useTheme();
  const [routeAnimationsEnabled, setRouteAnimationsEnabled] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setRouteAnimationsEnabled(false), 0);
    return () => window.clearTimeout(timer);
  }, []);

  if (!initialized) {
    return (
      <IonApp>
        <AuthListener />
        <AppToast />
        <div className="min-h-screen flex items-center justify-center bg-background">
          <div className="text-lg text-muted-foreground">Loading...</div>
        </div>
      </IonApp>
    );
  }

  return (
    <IonApp>
      <AuthListener />
      <AppToast />
      <IonReactRouter>
        <NativeAuthRedirectBoundary />
        <NativePushTapBoundary />
        {user && <NativePushRegistrationBoundary />}
        <IonRouterOutlet animated={routeAnimationsEnabled}>
          <Route path="/login" exact component={LoginPage} />
          <Route path="/invite/:token" exact component={AcceptInvitePage} />
          <Route path="/oauth/consent" exact component={OAuthConsentPage} />
          <AuthenticatedRoutes>
            <Route component={TabsLayout} />
          </AuthenticatedRoutes>
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
}

export default App;
